import i18n from '../localization.config'

export const getCaseStates = () => [
  {
    label: i18n.t('caseProperty:inCapture'),
    value: 'in_capture'
  },
  {
    label: i18n.t('caseProperty:open'),
    value: 'open'
  },
  {
    label: i18n.t('caseProperty:coverage_request'),
    value: 'coverage_request'
  },
  {
    label: i18n.t('caseProperty:in_progress'),
    value: 'in_progress'
  },
  {
    label: i18n.t('caseProperty:jump_off'),
    value: 'jump_off'
  },
  {
    label: i18n.t('caseProperty:completed'),
    value: 'completed'
  },
  {
    label: i18n.t('caseProperty:checked'),
    value: 'checked'
  },
  {
    label: i18n.t('caseProperty:settled'),
    value: 'settled'
  }
]
export const getSettlementRateEnum = () => [
  {
    label: '0 %',
    value: 0
  },
  {
    label: '100 %',
    value: 100
  }
]

export const getAgentFitEnum = () => [
  {
    label: i18n.t('caseProperty:ungeeignet'),
    value: 'ungeeignet'
  },
  {
    label: i18n.t('caseProperty:bedingt_geeignet'),
    value: 'bedingt_geeignet'
  },
  {
    label: i18n.t('caseProperty:geeignet'),
    value: 'geeignet'
  },
  {
    label: i18n.t('caseProperty:gut_geeignet'),
    value: 'gut_geeignet'
  }
]

export const getAgentCostCentreEnum = () => [
  {
    label: '2',
    value: '2'
  },
  {
    label: '3',
    value: '3'
  },
  {
    label: '4',
    value: '4'
  },
  {
    label: '5',
    value: '5'
  },
  {
    label: '6',
    value: '6'
  },
  {
    label: '9999',
    value: '9999'
  },
  {
    label: '0000',
    value: '0000'
  }
]

export const getClosingInfoEmailScheduleEnum = () => {
  const isPast6Pm = new Date().getHours() >= 18
  return [
    {
      label: i18n.t('closing:now'),
      value: 0
    },
    ...(isPast6Pm
      ? []
      : [
          {
            label: i18n.t('closing:todayAt6pm'),
            value: 1
          }
        ]),
    {
      label: i18n.t('closing:tomorrowAt3pm'),
      value: 2
    }
  ]
}

export const getCommunicationEnum = () => [
  {
    label: i18n.t('caseProperty:notAsked'),
    value: 'not_asked'
  },
  {
    label: i18n.t('common:yes'),
    value: 'yes'
  },
  {
    label: i18n.t('common:no'),
    value: 'no'
  }
]

export const getPayoutStatusEnum = () => [
  {
    label: i18n.t('processingProperty:payoutStatusReady'),
    value: 'ready'
  },
  {
    label: i18n.t('processingProperty:payoutStatusAdded'),
    value: 'added'
  },
  {
    label: i18n.t('processingProperty:payoutStatusPaid'),
    value: 'paid'
  },
  {
    label: i18n.t('processingProperty:payoutStatusCanceled'),
    value: 'canceled'
  },
  {
    label: i18n.t('processingProperty:payoutStatusFailed'),
    value: 'failed'
  }
]

export const getPaymentStatusEnum = () => [
  {
    label: i18n.t('caseProperty:open'),
    value: 'open'
  },
  {
    label: i18n.t('caseProperty:requested'),
    value: 'requested'
  },
  {
    label: i18n.t('caseProperty:paid'),
    value: 'paid'
  },
  {
    label: i18n.t('caseProperty:reminded'),
    value: 'reminded'
  },
  {
    label: i18n.t('caseProperty:expired'),
    value: 'expired'
  },
  {
    label: i18n.t('caseProperty:error'),
    value: 'error'
  },
  {
    label: i18n.t('caseProperty:canceled'),
    value: 'canceled'
  }
]

export const getAgentRoleEnum = () => [
  {
    label: i18n.t('common:admin'),
    value: 'admin'
  },
  {
    label: i18n.t('common:creator'),
    value: 'creator'
  },
  {
    label: i18n.t('common:user'),
    value: 'user'
  },
  {
    label: i18n.t('common:legal_advisor'),
    value: 'legal_advisor'
  }
]

export const getProcessingStates = () => [
  {
    label: i18n.t('caseProperty:open'),
    value: 'open'
  },
  {
    label: i18n.t('caseProperty:assigned'),
    value: 'assigned'
  },
  {
    label: i18n.t('caseProperty:accepted'),
    value: 'accepted'
  },
  {
    label: i18n.t('caseProperty:blocked'),
    value: 'blocked'
  },
  {
    label: i18n.t('caseProperty:first_contacted'),
    value: 'first_contacted'
  },
  {
    label: i18n.t('caseProperty:coverage_check'),
    value: 'coverage_check'
  },
  {
    label: i18n.t('caseProperty:in_progress'),
    value: 'in_progress'
  },
  {
    label: i18n.t('caseProperty:completed'),
    value: 'completed'
  },
  {
    label: i18n.t('caseProperty:checked'),
    value: 'checked'
  },
  {
    label: i18n.t('caseProperty:settled'),
    value: 'settled'
  },
  {
    label: i18n.t('caseProperty:transfer'),
    value: 'transfer'
  },
  {
    label: i18n.t('caseProperty:jump_off'),
    value: 'jump_off'
  }
]
